import actions from './actions';

const initState = {
    referralData: []
}

export default function gocarReducer(state = initState, action) {
    switch (action.type) {
        case actions.GOCAR_SIMPLE:
            return {...state, data: {...action.payload}}
        case actions.REGISTER_STATUS:
            return {data: action.data}
        case actions.VALIDATE_REFERRAL_SUCCESS:
        case actions.VALIDATE_REFERRAL_FAILURE:
            return {
                ...state,
                referralData: action.data
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/register/reducer.js